import { useNavigate, useSearchParams } from 'react-router-dom';
import AuthShell from '../components/AuthShell';
import Button from '../components/Button';
import Toast from '../components/Toast';
import { QUERY_PARAM_REASON, REASON_LABEL, REASON_REF, ROUTE_LOGIN } from '../constants';

const COPY_TITLE = 'Sign-in link expired';
const COPY_DEFAULT = 'This sign-in link is no longer valid.';
const COPY_BACK = 'Back to sign-in';

export default function Expired() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const reason = params.get(QUERY_PARAM_REASON) ?? '';
  const message = REASON_LABEL[reason] ?? COPY_DEFAULT;
  const diagnosticRef = REASON_REF[reason] ?? null;
  return (
    <AuthShell title={COPY_TITLE} diagnosticRef={diagnosticRef}>
      <div className="space-y-4">
        <Toast variant="info">{message}</Toast>
        <Button type="button" className="w-full" onClick={() => navigate(ROUTE_LOGIN)}>
          {COPY_BACK}
        </Button>
      </div>
    </AuthShell>
  );
}
